import type * as SchemaTypes from '../../../apolloClient.types';

import type { PerformanceResultListItemDataFragment, PerformanceResultWeightResultDataFragment, PerformanceResultIpptResultDataFragment, PerformanceResultSocResultDataFragment, PerformanceResultMarch20kmResultDataFragment, PerformanceResultFinSwimResultDataFragment, PerformanceResultBmpResultDataFragment } from '../../PerformanceResultsPage/shared/PerformanceResults.api';
import type { Ml360AssessmentResultDataFragment } from '../../AssessmentLauncher/ML360/ml360.api';
import type { SartAssessmentResultDataFragment } from '../../AssessmentLauncher/SART/Sart.api';
import type { SelfDeterminationAssessmentResultDataFragment } from '../../AssessmentLauncher/SelfDetermintation/SelfDetermination.api';
import type { IndividualMotivationAssessmentResultDataFragment, IndividualMotivationLikertScaleResultFragment, IndividualMotivationRatingScaleResultFragment } from '../../AssessmentLauncher/IndividualMotivation/IndividualMotivation.api';
import type { SpatialPlanningAssessmentResultDataFragment } from '../../AssessmentLauncher/SpatialPlanning/SpatialPlanning.api';
import type { TeamResilienceAssessmentResultDataFragment, TeamResilienceLikertScaleResultFragment, TeamResilienceRatingScaleResultFragment } from '../../AssessmentLauncher/TeamResilience/TeamResilience.api';
import type { VisualReactionAssessmentResultDataFragment } from '../../AssessmentLauncher/VisualReaction/VisualReaction.api';
import type { StrengthAssessmentResultDataFragment } from '../../PhysicalResultPage/Strength/Create/CreateStrengthAssessmentResult.api';
import type { CardioRespAssessmentResultDataFragment } from '../../PhysicalResultPage/CardioResp/Create/CreateCardioRespAssessmentResult.api';
import { gql } from '@apollo/client';
import { PerformanceResultListItemDataFragmentDoc, PerformanceResultWeightResultDataFragmentDoc, PerformanceResultIpptResultDataFragmentDoc, PerformanceResultSocResultDataFragmentDoc, PerformanceResultMarch20kmResultDataFragmentDoc, PerformanceResultFinSwimResultDataFragmentDoc, PerformanceResultBmpResultDataFragmentDoc } from '../../PerformanceResultsPage/shared/PerformanceResults.api';
import { Ml360AssessmentResultDataFragmentDoc } from '../../AssessmentLauncher/ML360/ml360.api';
import { SartAssessmentResultDataFragmentDoc } from '../../AssessmentLauncher/SART/Sart.api';
import { SelfDeterminationAssessmentResultDataFragmentDoc } from '../../AssessmentLauncher/SelfDetermintation/SelfDetermination.api';
import { IndividualMotivationAssessmentResultDataFragmentDoc, IndividualMotivationLikertScaleResultFragmentDoc, IndividualMotivationRatingScaleResultFragmentDoc } from '../../AssessmentLauncher/IndividualMotivation/IndividualMotivation.api';
import { SpatialPlanningAssessmentResultDataFragmentDoc } from '../../AssessmentLauncher/SpatialPlanning/SpatialPlanning.api';
import { TeamResilienceAssessmentResultDataFragmentDoc, TeamResilienceLikertScaleResultFragmentDoc, TeamResilienceRatingScaleResultFragmentDoc } from '../../AssessmentLauncher/TeamResilience/TeamResilience.api';
import { VisualReactionAssessmentResultDataFragmentDoc } from '../../AssessmentLauncher/VisualReaction/VisualReaction.api';
import { StrengthAssessmentResultDataFragmentDoc } from '../../PhysicalResultPage/Strength/Create/CreateStrengthAssessmentResult.api';
import { CardioRespAssessmentResultDataFragmentDoc } from '../../PhysicalResultPage/CardioResp/Create/CreateCardioRespAssessmentResult.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchTraineeReportsQueryVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  filter?: SchemaTypes.InputMaybe<SchemaTypes.TraineeReportFilterInput>;
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  sort?: SchemaTypes.InputMaybe<SchemaTypes.TraineeReportSortingRule>;
}>;


export type FetchTraineeReportsQuery = (
  { __typename: 'Query' }
  & { traineeReports: (
    { __typename: 'PaginatedTraineeReport' }
    & Pick<SchemaTypes.PaginatedTraineeReport, 'count'>
    & { items: Array<(
      { __typename: 'TraineeReportRow' }
      & TraineeReportRowDataFragment
    )> }
  ) }
);

export type FetchTraineePerformanceResultsQueryVariables = SchemaTypes.Exact<{
  filter?: SchemaTypes.InputMaybe<SchemaTypes.PerformanceResultFilterRule>;
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  sort?: SchemaTypes.InputMaybe<SchemaTypes.PerformanceResultSortingRule>;
}>;


export type FetchTraineePerformanceResultsQuery = (
  { __typename: 'Query' }
  & { performanceResults: (
    { __typename: 'PaginatedPerformanceResult' }
    & Pick<SchemaTypes.PaginatedPerformanceResult, 'count'>
    & { items: Array<(
      { __typename: 'PerformanceResult' }
      & PerformanceResultListItemDataFragment
    )> }
  ) }
);

export type TraineeReportRowDataFragment = (
  { __typename: 'TraineeReportRow' }
  & Pick<SchemaTypes.TraineeReportRow, 'userId' | 'assessmentRunId' | 'programId' | 'groupId' | 'traineeName' | 'programName' | 'assessmentRunName' | 'groupName' | 'subGroupName' | 'startDate' | 'endDate' | 'completionDate' | 'trainersNotes' | 'trainersNotesStatus' | 'canEdit'>
);

export type FetchTraineeAssessmentResultProgramsQueryVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  filter?: SchemaTypes.InputMaybe<SchemaTypes.ProgramFilteringRule>;
}>;


export type FetchTraineeAssessmentResultProgramsQuery = (
  { __typename: 'Query' }
  & { programs: (
    { __typename: 'PaginatedProgram' }
    & Pick<SchemaTypes.PaginatedProgram, 'count'>
    & { items: Array<(
      { __typename: 'Program' }
      & TraineeAssessmentResultProgramItemDataFragment
    )> }
  ) }
);

export type TraineeAssessmentResultProgramItemDataFragment = (
  { __typename: 'Program' }
  & Pick<SchemaTypes.Program, 'id' | 'name' | 'description' | 'courseInstanceId'>
  & { assessmentRuns: Array<(
    { __typename: 'AssessmentRun' }
    & TraineeAssessmentResultAssessmentRunDataFragment
  )>, courseInstance: (
    { __typename: 'CourseInstance' }
    & { executionSequence: Array<SchemaTypes.Maybe<(
      { __typename: 'ExecutionSequence' }
      & Pick<SchemaTypes.ExecutionSequence, 'moduleInstanceId' | 'order'>
      & { moduleInstance?: SchemaTypes.Maybe<(
        { __typename: 'ModuleInstance' }
        & AssessmentResultModuleInstanceDataFragment
      )> }
    )>> }
  ) }
);

export type TraineeAssessmentResultAssessmentRunDataFragment = (
  { __typename: 'AssessmentRun' }
  & Pick<SchemaTypes.AssessmentRun, 'id' | 'name' | 'status'>
  & { subGroups?: SchemaTypes.Maybe<Array<(
    { __typename: 'Subgroup' }
    & Pick<SchemaTypes.Subgroup, 'id' | 'name'>
  )>>, group: (
    { __typename: 'Group' }
    & TraineeAssessmentResultGroupFragment
  ) }
);

export type TraineeAssessmentResultGroupFragment = (
  { __typename: 'Group' }
  & Pick<SchemaTypes.Group, 'id' | 'name'>
  & { allMembers: Array<(
    { __typename: 'SuperAdminUser' }
    & TraineeAssessmentResultGroupMember_SuperAdminUser_Fragment
  ) | (
    { __typename: 'TenantUser' }
    & TraineeAssessmentResultGroupMember_TenantUser_Fragment
  )> }
);

export type TraineeAssessmentResultGroupMember_SuperAdminUser_Fragment = { __typename: 'SuperAdminUser' };

export type TraineeAssessmentResultGroupMember_TenantUser_Fragment = (
  { __typename: 'TenantUser' }
  & TenantUserReportDataFragment
);

export type TraineeAssessmentResultGroupMemberFragment = TraineeAssessmentResultGroupMember_SuperAdminUser_Fragment | TraineeAssessmentResultGroupMember_TenantUser_Fragment;

export type AssessmentResultModuleInstanceDataFragment = (
  { __typename: 'ModuleInstance' }
  & Pick<SchemaTypes.ModuleInstance, 'id' | 'name' | 'description' | 'moduleDefinitionIdentifier'>
);

export type TenantUserReportDataFragment = (
  { __typename: 'TenantUser' }
  & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email' | 'firstName' | 'lastName' | 'gender' | 'dateOfBirth' | 'height' | 'allGroupIds' | 'allSubGroupIds'>
  & { assignedGroups: Array<(
    { __typename: 'AssignedGroup' }
    & Pick<SchemaTypes.AssignedGroup, 'groupId' | 'subGroupIds'>
  )> }
);

export type AssessmentResultsQueryVariables = SchemaTypes.Exact<{
  filter?: SchemaTypes.InputMaybe<SchemaTypes.AssessmentResultFilterRule>;
}>;


export type AssessmentResultsQuery = (
  { __typename: 'Query' }
  & { assessmentResults: (
    { __typename: 'PaginatedAssessmentResult' }
    & Pick<SchemaTypes.PaginatedAssessmentResult, 'count'>
    & { items: Array<(
      { __typename: 'AssessmentResult' }
      & AssessmentResultItemDataFragment
    )>, teamResilienceItems?: SchemaTypes.Maybe<Array<(
      { __typename: 'AssessmentResult' }
      & AssessmentResultItemDataFragment
    )>> }
  ) }
);

export type IncompleteModulesQueryVariables = SchemaTypes.Exact<{
  programId: SchemaTypes.Scalars['ObjectID']['input'];
  userId: SchemaTypes.Scalars['ObjectID']['input'];
  assessmentRunId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type IncompleteModulesQuery = (
  { __typename: 'Query' }
  & { incompleteModules: Array<(
    { __typename: 'AssessmentResult' }
    & AssessmentResultItemDataFragment
  )> }
);

export type AssessmentResultItemDataFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'completedAt'>
  & { user?: SchemaTypes.Maybe<{ __typename: 'SuperAdminUser' } | (
    { __typename: 'TenantUser' }
    & TenantUserReportDataFragment
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & { program?: SchemaTypes.Maybe<(
      { __typename: 'Program' }
      & Pick<SchemaTypes.Program, 'id' | 'name'>
    )> }
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'id' | 'name' | 'moduleDefinitionIdentifier' | 'description'>
  )>, result: (
    { __typename: 'CardioRespResult' }
    & CardioRespAssessmentResultDataFragment
  ) | (
    { __typename: 'IndividualMotivationResult' }
    & IndividualMotivationAssessmentResultDataFragment
  ) | (
    { __typename: 'ML360Result' }
    & Ml360AssessmentResultDataFragment
  ) | (
    { __typename: 'SartResult' }
    & SartAssessmentResultDataFragment
  ) | (
    { __typename: 'SelfDeterminationResult' }
    & SelfDeterminationAssessmentResultDataFragment
  ) | (
    { __typename: 'SpatialPlanningResult' }
    & SpatialPlanningAssessmentResultDataFragment
  ) | (
    { __typename: 'StrengthResult' }
    & StrengthAssessmentResultDataFragment
  ) | (
    { __typename: 'TeamResilienceResult' }
    & TeamResilienceAssessmentResultDataFragment
  ) | (
    { __typename: 'TrainersNotesResult' }
    & TrainersNotesAssessmentResultDataFragment
  ) | (
    { __typename: 'VisualReactionResult' }
    & VisualReactionAssessmentResultDataFragment
  ) }
);

export type IpptAssessmentResultDataFragment = (
  { __typename: 'IpptResult' }
  & Pick<SchemaTypes.IpptResult, 'pushUps' | 'sitUps' | 'runTimeSec' | 'points' | 'pullUps' | 'award'>
);

export type TrainersNotesAssessmentResultDataFragment = (
  { __typename: 'TrainersNotesResult' }
  & Pick<SchemaTypes.TrainersNotesResult, 'trainersNotes' | 'status'>
);

export type UpdateTrainersNotesResultMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateTrainersNotesResultInput;
}>;


export type UpdateTrainersNotesResultMutation = (
  { __typename: 'Mutation' }
  & { updateTrainersNotesResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateTrainersNotesResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & Pick<SchemaTypes.AssessmentResult, 'id'>
      & { result: { __typename: 'CardioRespResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | (
        { __typename: 'TrainersNotesResult' }
        & Pick<SchemaTypes.TrainersNotesResult, 'trainersNotes' | 'status'>
      ) | { __typename: 'VisualReactionResult' } }
    )> }
  ) }
);

export type SubmitTrainersNotesResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitTrainersNotesResultInput;
}>;


export type SubmitTrainersNotesResultMutation = (
  { __typename: 'Mutation' }
  & { submitTrainersNotesResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitTrainersNotesResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & Pick<SchemaTypes.AssessmentResult, 'id'>
      & { result: { __typename: 'CardioRespResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | (
        { __typename: 'TrainersNotesResult' }
        & Pick<SchemaTypes.TrainersNotesResult, 'trainersNotes' | 'status'>
      ) | { __typename: 'VisualReactionResult' } }
    )> }
  ) }
);

export type GenerateTrainersNotesMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.GenerateTrainersNotesInput;
}>;


export type GenerateTrainersNotesMutation = (
  { __typename: 'Mutation' }
  & { generateTrainersNotes: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'GenerateTrainersNotesSuccessfulResponse' }
    & Pick<SchemaTypes.GenerateTrainersNotesSuccessfulResponse, 'suggestion'>
  ) }
);

export type FetchUserDocumentQueryVariables = SchemaTypes.Exact<{
  userId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type FetchUserDocumentQuery = (
  { __typename: 'Query' }
  & { user?: SchemaTypes.Maybe<{ __typename: 'SuperAdminUser' } | (
    { __typename: 'TenantUser' }
    & TenantUserReportDataFragment
  )> }
);

export const TraineeReportRowDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeReportRowData on TraineeReportRow {
  userId
  assessmentRunId
  programId
  groupId
  traineeName
  programName
  assessmentRunName
  groupName
  subGroupName
  startDate
  endDate
  completionDate
  trainersNotes
  trainersNotesStatus
  canEdit
}
    `;
export const TenantUserReportDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TenantUserReportData on TenantUser {
  id
  name
  email
  firstName
  lastName
  gender
  dateOfBirth
  height
  assignedGroups {
    groupId
    subGroupIds
  }
  allGroupIds
  allSubGroupIds
}
    `;
export const TraineeAssessmentResultGroupMemberFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentResultGroupMember on User {
  ... on TenantUser {
    ...TenantUserReportData
  }
}
    `;
export const TraineeAssessmentResultGroupFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentResultGroup on Group {
  id
  name
  allMembers {
    ...TraineeAssessmentResultGroupMember
  }
}
    `;
export const TraineeAssessmentResultAssessmentRunDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentResultAssessmentRunData on AssessmentRun {
  id
  name
  status
  subGroups {
    id
    name
  }
  group {
    ...TraineeAssessmentResultGroup
  }
}
    `;
export const AssessmentResultModuleInstanceDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultModuleInstanceData on ModuleInstance {
  id
  name
  description
  moduleDefinitionIdentifier
}
    `;
export const TraineeAssessmentResultProgramItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentResultProgramItemData on Program {
  id
  name
  description
  courseInstanceId
  assessmentRuns {
    ...TraineeAssessmentResultAssessmentRunData
  }
  courseInstance {
    executionSequence {
      moduleInstanceId
      order
      moduleInstance {
        ...AssessmentResultModuleInstanceData
      }
    }
  }
}
    `;
export const TrainersNotesAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TrainersNotesAssessmentResultData on TrainersNotesResult {
  trainersNotes
  status
}
    `;
export const AssessmentResultItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultItemData on AssessmentResult {
  id
  user {
    ... on TenantUser {
      ...TenantUserReportData
    }
  }
  assessmentRun {
    program {
      id
      name
    }
  }
  moduleInstance {
    id
    name
    moduleDefinitionIdentifier
    description
  }
  completedAt
  result {
    ... on ML360Result {
      ...ML360AssessmentResultData
    }
    ... on SartResult {
      ...SartAssessmentResultData
    }
    ... on SelfDeterminationResult {
      ...SelfDeterminationAssessmentResultData
    }
    ... on IndividualMotivationResult {
      ...IndividualMotivationAssessmentResultData
    }
    ... on SpatialPlanningResult {
      ...SpatialPlanningAssessmentResultData
    }
    ... on TeamResilienceResult {
      ...TeamResilienceAssessmentResultData
    }
    ... on VisualReactionResult {
      ...VisualReactionAssessmentResultData
    }
    ... on StrengthResult {
      ...StrengthAssessmentResultData
    }
    ... on CardioRespResult {
      ...CardioRespAssessmentResultData
    }
    ... on TrainersNotesResult {
      ...TrainersNotesAssessmentResultData
    }
  }
}
    `;
export const IpptAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment IPPTAssessmentResultData on IpptResult {
  pushUps
  sitUps
  runTimeSec
  points
  pullUps
  award
}
    `;
export const FetchTraineeReportsDocument = /*#__PURE__*/ gql`
    query FetchTraineeReports($companyId: ObjectID!, $filter: TraineeReportFilterInput, $pagination: Pagination, $sort: TraineeReportSortingRule) {
  traineeReports(
    companyId: $companyId
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    count
    items {
      ...TraineeReportRowData
    }
  }
}
    ${TraineeReportRowDataFragmentDoc}`;

/**
 * __useFetchTraineeReportsQuery__
 *
 * To run a query within a React component, call `useFetchTraineeReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTraineeReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTraineeReportsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFetchTraineeReportsQuery(baseOptions: Apollo.QueryHookOptions<FetchTraineeReportsQuery, FetchTraineeReportsQueryVariables> & ({ variables: FetchTraineeReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTraineeReportsQuery, FetchTraineeReportsQueryVariables>(FetchTraineeReportsDocument, options);
      }
export function useFetchTraineeReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTraineeReportsQuery, FetchTraineeReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTraineeReportsQuery, FetchTraineeReportsQueryVariables>(FetchTraineeReportsDocument, options);
        }
export function useFetchTraineeReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTraineeReportsQuery, FetchTraineeReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTraineeReportsQuery, FetchTraineeReportsQueryVariables>(FetchTraineeReportsDocument, options);
        }
export type FetchTraineeReportsQueryHookResult = ReturnType<typeof useFetchTraineeReportsQuery>;
export type FetchTraineeReportsLazyQueryHookResult = ReturnType<typeof useFetchTraineeReportsLazyQuery>;
export type FetchTraineeReportsSuspenseQueryHookResult = ReturnType<typeof useFetchTraineeReportsSuspenseQuery>;
export type FetchTraineeReportsQueryResult = Apollo.QueryResult<FetchTraineeReportsQuery, FetchTraineeReportsQueryVariables>;
export const FetchTraineePerformanceResultsDocument = /*#__PURE__*/ gql`
    query FetchTraineePerformanceResults($filter: PerformanceResultFilterRule, $pagination: Pagination, $sort: PerformanceResultSortingRule) {
  performanceResults(filter: $filter, pagination: $pagination, sort: $sort) {
    count
    items {
      ...PerformanceResultListItemData
    }
  }
}
    ${PerformanceResultListItemDataFragmentDoc}
${PerformanceResultWeightResultDataFragmentDoc}
${PerformanceResultIpptResultDataFragmentDoc}
${PerformanceResultSocResultDataFragmentDoc}
${PerformanceResultMarch20kmResultDataFragmentDoc}
${PerformanceResultFinSwimResultDataFragmentDoc}
${PerformanceResultBmpResultDataFragmentDoc}`;

/**
 * __useFetchTraineePerformanceResultsQuery__
 *
 * To run a query within a React component, call `useFetchTraineePerformanceResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTraineePerformanceResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTraineePerformanceResultsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFetchTraineePerformanceResultsQuery(baseOptions?: Apollo.QueryHookOptions<FetchTraineePerformanceResultsQuery, FetchTraineePerformanceResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTraineePerformanceResultsQuery, FetchTraineePerformanceResultsQueryVariables>(FetchTraineePerformanceResultsDocument, options);
      }
export function useFetchTraineePerformanceResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTraineePerformanceResultsQuery, FetchTraineePerformanceResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTraineePerformanceResultsQuery, FetchTraineePerformanceResultsQueryVariables>(FetchTraineePerformanceResultsDocument, options);
        }
export function useFetchTraineePerformanceResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTraineePerformanceResultsQuery, FetchTraineePerformanceResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTraineePerformanceResultsQuery, FetchTraineePerformanceResultsQueryVariables>(FetchTraineePerformanceResultsDocument, options);
        }
export type FetchTraineePerformanceResultsQueryHookResult = ReturnType<typeof useFetchTraineePerformanceResultsQuery>;
export type FetchTraineePerformanceResultsLazyQueryHookResult = ReturnType<typeof useFetchTraineePerformanceResultsLazyQuery>;
export type FetchTraineePerformanceResultsSuspenseQueryHookResult = ReturnType<typeof useFetchTraineePerformanceResultsSuspenseQuery>;
export type FetchTraineePerformanceResultsQueryResult = Apollo.QueryResult<FetchTraineePerformanceResultsQuery, FetchTraineePerformanceResultsQueryVariables>;
export const FetchTraineeAssessmentResultProgramsDocument = /*#__PURE__*/ gql`
    query FetchTraineeAssessmentResultPrograms($companyId: ObjectID!, $filter: ProgramFilteringRule) {
  programs(companyId: $companyId, filter: $filter) {
    count
    items {
      ...TraineeAssessmentResultProgramItemData
    }
  }
}
    ${TraineeAssessmentResultProgramItemDataFragmentDoc}
${TraineeAssessmentResultAssessmentRunDataFragmentDoc}
${TraineeAssessmentResultGroupFragmentDoc}
${TraineeAssessmentResultGroupMemberFragmentDoc}
${TenantUserReportDataFragmentDoc}
${AssessmentResultModuleInstanceDataFragmentDoc}`;

/**
 * __useFetchTraineeAssessmentResultProgramsQuery__
 *
 * To run a query within a React component, call `useFetchTraineeAssessmentResultProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTraineeAssessmentResultProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTraineeAssessmentResultProgramsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTraineeAssessmentResultProgramsQuery(baseOptions: Apollo.QueryHookOptions<FetchTraineeAssessmentResultProgramsQuery, FetchTraineeAssessmentResultProgramsQueryVariables> & ({ variables: FetchTraineeAssessmentResultProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTraineeAssessmentResultProgramsQuery, FetchTraineeAssessmentResultProgramsQueryVariables>(FetchTraineeAssessmentResultProgramsDocument, options);
      }
export function useFetchTraineeAssessmentResultProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTraineeAssessmentResultProgramsQuery, FetchTraineeAssessmentResultProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTraineeAssessmentResultProgramsQuery, FetchTraineeAssessmentResultProgramsQueryVariables>(FetchTraineeAssessmentResultProgramsDocument, options);
        }
export function useFetchTraineeAssessmentResultProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTraineeAssessmentResultProgramsQuery, FetchTraineeAssessmentResultProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTraineeAssessmentResultProgramsQuery, FetchTraineeAssessmentResultProgramsQueryVariables>(FetchTraineeAssessmentResultProgramsDocument, options);
        }
export type FetchTraineeAssessmentResultProgramsQueryHookResult = ReturnType<typeof useFetchTraineeAssessmentResultProgramsQuery>;
export type FetchTraineeAssessmentResultProgramsLazyQueryHookResult = ReturnType<typeof useFetchTraineeAssessmentResultProgramsLazyQuery>;
export type FetchTraineeAssessmentResultProgramsSuspenseQueryHookResult = ReturnType<typeof useFetchTraineeAssessmentResultProgramsSuspenseQuery>;
export type FetchTraineeAssessmentResultProgramsQueryResult = Apollo.QueryResult<FetchTraineeAssessmentResultProgramsQuery, FetchTraineeAssessmentResultProgramsQueryVariables>;
export const AssessmentResultsDocument = /*#__PURE__*/ gql`
    query AssessmentResults($filter: AssessmentResultFilterRule) {
  assessmentResults(filter: $filter) {
    count
    items {
      ...AssessmentResultItemData
    }
    teamResilienceItems {
      ...AssessmentResultItemData
    }
  }
}
    ${AssessmentResultItemDataFragmentDoc}
${TenantUserReportDataFragmentDoc}
${Ml360AssessmentResultDataFragmentDoc}
${SartAssessmentResultDataFragmentDoc}
${SelfDeterminationAssessmentResultDataFragmentDoc}
${IndividualMotivationAssessmentResultDataFragmentDoc}
${IndividualMotivationLikertScaleResultFragmentDoc}
${IndividualMotivationRatingScaleResultFragmentDoc}
${SpatialPlanningAssessmentResultDataFragmentDoc}
${TeamResilienceAssessmentResultDataFragmentDoc}
${TeamResilienceLikertScaleResultFragmentDoc}
${TeamResilienceRatingScaleResultFragmentDoc}
${VisualReactionAssessmentResultDataFragmentDoc}
${StrengthAssessmentResultDataFragmentDoc}
${CardioRespAssessmentResultDataFragmentDoc}
${TrainersNotesAssessmentResultDataFragmentDoc}`;

/**
 * __useAssessmentResultsQuery__
 *
 * To run a query within a React component, call `useAssessmentResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentResultsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAssessmentResultsQuery(baseOptions?: Apollo.QueryHookOptions<AssessmentResultsQuery, AssessmentResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentResultsQuery, AssessmentResultsQueryVariables>(AssessmentResultsDocument, options);
      }
export function useAssessmentResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentResultsQuery, AssessmentResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentResultsQuery, AssessmentResultsQueryVariables>(AssessmentResultsDocument, options);
        }
export function useAssessmentResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentResultsQuery, AssessmentResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentResultsQuery, AssessmentResultsQueryVariables>(AssessmentResultsDocument, options);
        }
export type AssessmentResultsQueryHookResult = ReturnType<typeof useAssessmentResultsQuery>;
export type AssessmentResultsLazyQueryHookResult = ReturnType<typeof useAssessmentResultsLazyQuery>;
export type AssessmentResultsSuspenseQueryHookResult = ReturnType<typeof useAssessmentResultsSuspenseQuery>;
export type AssessmentResultsQueryResult = Apollo.QueryResult<AssessmentResultsQuery, AssessmentResultsQueryVariables>;
export const IncompleteModulesDocument = /*#__PURE__*/ gql`
    query IncompleteModules($programId: ObjectID!, $userId: ObjectID!, $assessmentRunId: ObjectID!) {
  incompleteModules(
    programId: $programId
    userId: $userId
    assessmentRunId: $assessmentRunId
  ) {
    ...AssessmentResultItemData
  }
}
    ${AssessmentResultItemDataFragmentDoc}
${TenantUserReportDataFragmentDoc}
${Ml360AssessmentResultDataFragmentDoc}
${SartAssessmentResultDataFragmentDoc}
${SelfDeterminationAssessmentResultDataFragmentDoc}
${IndividualMotivationAssessmentResultDataFragmentDoc}
${IndividualMotivationLikertScaleResultFragmentDoc}
${IndividualMotivationRatingScaleResultFragmentDoc}
${SpatialPlanningAssessmentResultDataFragmentDoc}
${TeamResilienceAssessmentResultDataFragmentDoc}
${TeamResilienceLikertScaleResultFragmentDoc}
${TeamResilienceRatingScaleResultFragmentDoc}
${VisualReactionAssessmentResultDataFragmentDoc}
${StrengthAssessmentResultDataFragmentDoc}
${CardioRespAssessmentResultDataFragmentDoc}
${TrainersNotesAssessmentResultDataFragmentDoc}`;

/**
 * __useIncompleteModulesQuery__
 *
 * To run a query within a React component, call `useIncompleteModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncompleteModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncompleteModulesQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      userId: // value for 'userId'
 *      assessmentRunId: // value for 'assessmentRunId'
 *   },
 * });
 */
export function useIncompleteModulesQuery(baseOptions: Apollo.QueryHookOptions<IncompleteModulesQuery, IncompleteModulesQueryVariables> & ({ variables: IncompleteModulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncompleteModulesQuery, IncompleteModulesQueryVariables>(IncompleteModulesDocument, options);
      }
export function useIncompleteModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncompleteModulesQuery, IncompleteModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncompleteModulesQuery, IncompleteModulesQueryVariables>(IncompleteModulesDocument, options);
        }
export function useIncompleteModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncompleteModulesQuery, IncompleteModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncompleteModulesQuery, IncompleteModulesQueryVariables>(IncompleteModulesDocument, options);
        }
export type IncompleteModulesQueryHookResult = ReturnType<typeof useIncompleteModulesQuery>;
export type IncompleteModulesLazyQueryHookResult = ReturnType<typeof useIncompleteModulesLazyQuery>;
export type IncompleteModulesSuspenseQueryHookResult = ReturnType<typeof useIncompleteModulesSuspenseQuery>;
export type IncompleteModulesQueryResult = Apollo.QueryResult<IncompleteModulesQuery, IncompleteModulesQueryVariables>;
export const UpdateTrainersNotesResultDocument = /*#__PURE__*/ gql`
    mutation UpdateTrainersNotesResult($id: ObjectID!, $input: UpdateTrainersNotesResultInput!) {
  updateTrainersNotesResult(id: $id, input: $input) {
    __typename
    ... on UpdateTrainersNotesResultSuccessfulResponse {
      result {
        id
        result {
          ... on TrainersNotesResult {
            trainersNotes
            status
          }
        }
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type UpdateTrainersNotesResultMutationFn = Apollo.MutationFunction<UpdateTrainersNotesResultMutation, UpdateTrainersNotesResultMutationVariables>;

/**
 * __useUpdateTrainersNotesResultMutation__
 *
 * To run a mutation, you first call `useUpdateTrainersNotesResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainersNotesResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainersNotesResultMutation, { data, loading, error }] = useUpdateTrainersNotesResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainersNotesResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainersNotesResultMutation, UpdateTrainersNotesResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainersNotesResultMutation, UpdateTrainersNotesResultMutationVariables>(UpdateTrainersNotesResultDocument, options);
      }
export type UpdateTrainersNotesResultMutationHookResult = ReturnType<typeof useUpdateTrainersNotesResultMutation>;
export type UpdateTrainersNotesResultMutationResult = Apollo.MutationResult<UpdateTrainersNotesResultMutation>;
export type UpdateTrainersNotesResultMutationOptions = Apollo.BaseMutationOptions<UpdateTrainersNotesResultMutation, UpdateTrainersNotesResultMutationVariables>;
export const SubmitTrainersNotesResultDocument = /*#__PURE__*/ gql`
    mutation SubmitTrainersNotesResult($input: SubmitTrainersNotesResultInput!) {
  submitTrainersNotesResult(input: $input) {
    __typename
    ... on SubmitTrainersNotesResultSuccessfulResponse {
      result {
        id
        result {
          ... on TrainersNotesResult {
            trainersNotes
            status
          }
        }
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type SubmitTrainersNotesResultMutationFn = Apollo.MutationFunction<SubmitTrainersNotesResultMutation, SubmitTrainersNotesResultMutationVariables>;

/**
 * __useSubmitTrainersNotesResultMutation__
 *
 * To run a mutation, you first call `useSubmitTrainersNotesResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTrainersNotesResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTrainersNotesResultMutation, { data, loading, error }] = useSubmitTrainersNotesResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTrainersNotesResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTrainersNotesResultMutation, SubmitTrainersNotesResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTrainersNotesResultMutation, SubmitTrainersNotesResultMutationVariables>(SubmitTrainersNotesResultDocument, options);
      }
export type SubmitTrainersNotesResultMutationHookResult = ReturnType<typeof useSubmitTrainersNotesResultMutation>;
export type SubmitTrainersNotesResultMutationResult = Apollo.MutationResult<SubmitTrainersNotesResultMutation>;
export type SubmitTrainersNotesResultMutationOptions = Apollo.BaseMutationOptions<SubmitTrainersNotesResultMutation, SubmitTrainersNotesResultMutationVariables>;
export const GenerateTrainersNotesDocument = /*#__PURE__*/ gql`
    mutation GenerateTrainersNotes($input: GenerateTrainersNotesInput!) {
  generateTrainersNotes(input: $input) {
    __typename
    ... on GenerateTrainersNotesSuccessfulResponse {
      suggestion
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type GenerateTrainersNotesMutationFn = Apollo.MutationFunction<GenerateTrainersNotesMutation, GenerateTrainersNotesMutationVariables>;

/**
 * __useGenerateTrainersNotesMutation__
 *
 * To run a mutation, you first call `useGenerateTrainersNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTrainersNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTrainersNotesMutation, { data, loading, error }] = useGenerateTrainersNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateTrainersNotesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTrainersNotesMutation, GenerateTrainersNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTrainersNotesMutation, GenerateTrainersNotesMutationVariables>(GenerateTrainersNotesDocument, options);
      }
export type GenerateTrainersNotesMutationHookResult = ReturnType<typeof useGenerateTrainersNotesMutation>;
export type GenerateTrainersNotesMutationResult = Apollo.MutationResult<GenerateTrainersNotesMutation>;
export type GenerateTrainersNotesMutationOptions = Apollo.BaseMutationOptions<GenerateTrainersNotesMutation, GenerateTrainersNotesMutationVariables>;
export const FetchUserDocumentDocument = /*#__PURE__*/ gql`
    query FetchUserDocument($userId: ObjectID!) {
  user(id: $userId) {
    ... on TenantUser {
      ...TenantUserReportData
    }
  }
}
    ${TenantUserReportDataFragmentDoc}`;

/**
 * __useFetchUserDocumentQuery__
 *
 * To run a query within a React component, call `useFetchUserDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserDocumentQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserDocumentQuery(baseOptions: Apollo.QueryHookOptions<FetchUserDocumentQuery, FetchUserDocumentQueryVariables> & ({ variables: FetchUserDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserDocumentQuery, FetchUserDocumentQueryVariables>(FetchUserDocumentDocument, options);
      }
export function useFetchUserDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserDocumentQuery, FetchUserDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserDocumentQuery, FetchUserDocumentQueryVariables>(FetchUserDocumentDocument, options);
        }
export function useFetchUserDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchUserDocumentQuery, FetchUserDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchUserDocumentQuery, FetchUserDocumentQueryVariables>(FetchUserDocumentDocument, options);
        }
export type FetchUserDocumentQueryHookResult = ReturnType<typeof useFetchUserDocumentQuery>;
export type FetchUserDocumentLazyQueryHookResult = ReturnType<typeof useFetchUserDocumentLazyQuery>;
export type FetchUserDocumentSuspenseQueryHookResult = ReturnType<typeof useFetchUserDocumentSuspenseQuery>;
export type FetchUserDocumentQueryResult = Apollo.QueryResult<FetchUserDocumentQuery, FetchUserDocumentQueryVariables>;